var React = require('react');

function ArrowRight2 (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M77.9654 20.1998L57.9551 1.58556L59.0449 0.414062L80.5449 20.4141L81.1746 20.9998L80.5449 21.5856L59.0449 41.5856L57.9551 40.4141L77.9654 21.7998L0 21.7998V20.1998L77.9654 20.1998Z","fill":"#303030"}));
}

ArrowRight2.defaultProps = {"width":"82","height":"42","viewBox":"0 0 82 42","fill":"none"};

module.exports = ArrowRight2;

ArrowRight2.default = ArrowRight2;
